import type { UseHttp } from '~~/server/api/interface'

export const fetchNewsHomePageList: UseHttp = (params, option) => {
  return useHttp.post('/api/newsApi/homePageList', params, { ...option })
}

export const fetchNewsApiGetNews: UseHttp = (params, option) => {
  return useHttp.post('/api/newsApi/getNews', params, { ...option })
}

export const getNewsByExhibitionId: UseHttp = (params, option) => {
  return useHttp.post('/api/newsApi/getNewsbyExhibitionId/', params, { ...option })
}

export const fetchNewsById: UseHttp = (params, option) => {
  return useHttp.post('/api/newsApi/get', params, { ...option })
}

export const fetchNewsViewById: UseHttp = (params, option) => {
  return useHttp.post(`/api/newsApi/getNewsView/${params?.id}`, params, { ...option })
}

export const fetchNewsRelatedById: UseHttp = (params, option) => {
  return useHttp.post(`/api/news/get/related/${params?.id}`, params, { ...option })
}

export const fetchNewsCountById: UseHttp = (params, option) => {
  return useHttp.post('/api/newsApi/getAndCount', params, { ...option })
}

export const fetchNewsAttentionById: UseHttp = (params, option) => {
  return useHttp.get(`/api/news/attention/${params?.id}`, params, { ...option })
}

export const fetchPageBanner: UseHttp = (params, option) => {
  return useHttp.post('/api/bannerApi/page', params, {
    ...option
  })
}

export const clientFetchPageBanner: UseHttp = (params, option) => {
  return useHttp.post('/api/bannerApi/page', params, option)
}
export const fetchCompanyByKeyword: UseHttp = (params, option) => {
  return useHttp.post('/api/companyApi/keyWord', params?.value, { ...option })
}
export const fetchCompanyCooperateSave: UseHttp = (params, option) => {
  return useHttp.post('/api/companyCooperate/save', params, { ...option })
}
export const fetchExhibitorList: UseHttp = (params, option) => {
  return useHttp.post(`/api/exhibitorApi/list`, params, { ...option })
}
export const exhibitorCheckUser: UseHttp = (params, option) => {
  return useHttp.post(`/api/exhibitorApi/checkUser`, params, { ...option })
}

export const fetchHRStaffServices: UseHttp = (params, option) => {
  return useHttp.post('/api/hr/staff/services', params, { ...option })
}
export const fetchIndustryGetAll: UseHttp = (params, option) => {
  return useHttp.get('/api/industry/getAll', params, {
    ...option
  })
}
export const fetchInnerChainPage: UseHttp = (params, option) => {
  return useHttp.post('/api/innerChain/page', params, { ...option })
}

export const fetchLetterPageList: UseHttp = (params, option) => {
  return useHttp.post('/api/innerChain/letter/pageList', params, { ...option })
}

export const fetchAllLetterDataList: UseHttp = (params, option) => {
  return useHttp.post('/api/innerChain/letter/allLetterDataList', params, { ...option })
}
export const fetchLinksById: UseHttp = (params, option) => {
  return useHttp.get(`/api/index/links/${params?.id}`, undefined, { ...option })
}
export const clientFetchMessagesById: UseHttp = (params, option) => {
  return useHttp.post(`/api/todayMessagesApi/getMessages/${params?.id}`, undefined, { ...option })
}
export const fetchPavilionList: UseHttp = (params, option) => {
  return useHttp.post('/api/pavilionApi/list', params, { ...option })
}

export const fetchExhibitionPavilionById: UseHttp = (params, option) => {
  return useHttp.get(`/api/exhibitionPavilion/${params?.id}`, params, { ...option })
}
export const fetchNewPeriodical: UseHttp = (params, option) => {
  return useHttp.get(`/api/periodicalApi/getNewPeriodical/${params?.id}`, undefined, { ...option })
}

export const clientFetchNewPeriodical: UseHttp = (params, option) => {
  return useHttp.get(`/api/periodicalApi/getNewPeriodical/${params?.id}`, undefined, { ...option })
}

export const fetchPeriodicalById: UseHttp = (params, option) => {
  return useHttp.get(`/api/periodical/periodicalList/${params?.id}`, undefined, { ...option })
}
export const fetchGetLatestPoster: UseHttp = (params, option) => {
  return useHttp.get(`/api/poster/getLatestPoster?tag=${params?.tag}`, undefined, { ...option })
}
export const fetchSpecialTopicByResourceId: UseHttp = (params, option) => {
  return useHttp.post('/api/specialTopicApi/resourceId', params, { ...option })
}

export const fetchSubsidyListByEid: UseHttp = (params, option) => {
  return useHttp.post('/api/subsidy/listByEid', params, { ...option })
}
// newsApi - 修改为使用新的健康检查接口
export const fetchSysHealthCheck: UseHttp = (params, option) => {
  return useHttp.get('/health', undefined, { ...option })
}
